import React, { useState, useCallback } from "react";
import { UnifiedAgentSidebar } from "../../agent/shared/UnifiedAgentSidebar";
import { AgentSessionProvider } from "../../agent/shared/AgentSessionContext";
import { ClientAgentChat } from "./ClientAgentChat";

// Bloque autocontenido del chat de Dashbito para un cliente (sidebar de sesiones + chat).
// Extraído de ClientAgentContent para poder embeberlo también como sub-vista del tab IA
// (ficha v2) sin duplicar el wiring del AgentSessionProvider. `sessionBasePath` (opcional):
// el tab IA pasa '/client/:id/ia/dashbito' para que la navegación interna del chat quede
// dentro del tab (sin rebotar por la ruta legacy).
export const ClientAgentArea = ({ clientId, sessionId, adAccounts, businessUnits, sessionBasePath = null }) => {
    const [chatKey, setChatKey] = useState(0);

    const handleNewChat = useCallback(() => {
        setChatKey(k => k + 1);
    }, []);

    const handleSessionCreated = useCallback(() => {
        // El contexto refresca automáticamente al cambiar activeSessionId
    }, []);

    const handleSessionNameUpdate = useCallback(() => {
        // Manejado por el contexto
    }, []);

    return (
        <AgentSessionProvider entryPoint="client" clientId={clientId} activeSessionId={sessionId}
                              sessionBasePath={sessionBasePath}>
            <div className="agent-area">
                <UnifiedAgentSidebar onNewChat={handleNewChat} />
                <ClientAgentChat
                    key={chatKey}
                    clientId={clientId}
                    sessionId={sessionId}
                    onSessionCreated={handleSessionCreated}
                    onSessionNameUpdate={handleSessionNameUpdate}
                    adAccounts={adAccounts}
                    businessUnits={businessUnits}
                />
            </div>
        </AgentSessionProvider>
    );
};
